module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.parsedData.email))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [(this.$route.params.id) ? _c('submenu') : _vm._e(), _vm._v(" "), _vm._m(0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form js-form"
  }, [_c('div', {
    staticClass: "jquery-alpaca-edit"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c6ee2f3!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/members/Member.vue
// module id = 750
// module chunks = 1